import React, { useState, useEffect } from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import defaultTexts from '../../../texts/texts'
import CustomCheckboxField from '../../_common/_form_fields/CustomCheckboxField'
import OpenStackServicesViewRegion from './OpenStackServicesViewRegion'

const OpenStackServicesViewService = (props) => {
  const {
    serviceName,
    backendServices,
    billingServices,
    supportedServiceConfigs,
    expandedPanel,
    handleChangeExpandedPanel,
  } = props
  const theme = useTheme()

  const [expandedSubPanel, setExpandedSubPanel] = useState(0)
  const [regions, setRegions] = useState([])

  const accordionStyle = {
    background: 'none',
    boxShadow: 'none'
  }

  const summaryStyle = {
    background: theme.palette.violetsAreBlue,
    color: 'white',
    fontSize: '18px',
  }

  const detailsStyle = {
    border: `${theme.palette.violetsAreBlue} 1px solid`,
    background: 'white',
    boxShadow: 'none',
    padding: '0px',
  }

  const regionSummaryStyle = {
    borderBottom: `${theme.palette.oxfordBlue} 1px solid`,
    color: theme.palette.oxfordBlue,
    fontSize: '18px',
    fontWeight: '500',
  }

  const serviceCheckboxStyle = {
    color: 'white',

    '&.Mui-checked': {
      color: 'white',
    },

    '& .MuiSvgIcon-root': {
      fontSize: 24,
    },
  }

  const regionCheckboxStyle = {
    color: theme.palette.violetsAreBlue,

    '&.Mui-checked': {
      color: theme.palette.violetsAreBlue,
    },

    '& .MuiSvgIcon-root': {
      fontSize: 24,
    },
  }

  const handleChangeExpandedSubPanel = (panel) => (event, newExpanded) => {
    setExpandedSubPanel(newExpanded ? panel : false)
  }

  const getServiceTitle = () => {
    const service_object = supportedServiceConfigs.find(item => item.service === serviceName)
    return service_object ? service_object.title.value : serviceName
  }

  const getServiceChecked = () => {
    let result = false

    if (backendServices.length > 0) {
      const billing_service = billingServices.find(item => item.service_name === serviceName)
      result = billing_service ? true : false
    } else {
      result = true
    }

    return result
  }

  const getRegionTitle = (item) => {
    let result = ''

    if (item.config_params) {
      result = item.config_params.region_name ? item.config_params.region_name : item.config_params.default_region
    } else {
      result = item.region_name
    }

    return result
  }

  const getRegionChecked = (item) => {
    let result = false

    const region_name = getRegionTitle(item)

    if (backendServices.length > 0) {
      const billing_service = billingServices.find(item => item.service_name === serviceName && item.region_name === region_name)
      result = billing_service ? true : false
    } else {
      result = true
    }

    return result
  }

  useEffect(() => {
    if (backendServices.length > 0) {
      setRegions(backendServices.filter(item => item.service === serviceName))
    } else {
      setRegions(billingServices.filter(item => item.service_name === serviceName))
    }
  }, [backendServices, billingServices, serviceName])
  
  return (
    <>
      <Accordion
        expanded={expandedPanel === serviceName}
        onChange={handleChangeExpandedPanel(serviceName)}
        sx={accordionStyle}
      >
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon sx={{ color: 'white' }} />}
          sx={{
            ...summaryStyle,
            borderRadius: expandedPanel === serviceName ? '10px 10px 0px 0px' : '0px',
          }}
        >
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='flex-start'
            spacing={1}
          >
            <Box>
              <CustomCheckboxField
                checked={getServiceChecked()}
                handleChange={() => {}}
                sx={serviceCheckboxStyle}
              />
            </Box>
            <Box>{getServiceTitle()}</Box>    
          </Stack>          
        </AccordionSummary>
        <AccordionDetails sx={detailsStyle}>
          
          {
            regions.length === 0 &&
            <Box
              sx={{
                padding: '20px',
                fontSize: '20px',
              }}
            >
              {defaultTexts.notConfigured}
            </Box>
          }

          {
            regions.length === 1 && regions.map((item, index) => (
              <Box key={index} sx={{ padding: '20px' }}>
                <OpenStackServicesViewRegion
                  {...item}
                  billingServices={billingServices}
                  showBillingFields={getServiceChecked()}
                />
              </Box>              
            ))
          }

          {
            regions.length > 1 && regions.map((item, index) => (
              <Accordion
                key={index}
                expanded={expandedSubPanel === index}
                onChange={handleChangeExpandedSubPanel(index)}
                sx={accordionStyle}
              >
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  sx={regionSummaryStyle}
                >
                  <Stack
                    direction='row'
                    alignItems='center'
                    justifyContent='flex-start'
                    spacing={1}
                  >
                    <Box>
                      <CustomCheckboxField
                        checked={getRegionChecked(item)}
                        handleChange={() => {}}
                        sx={regionCheckboxStyle}
                      />
                    </Box>
                    <Box>{getRegionTitle(item)}</Box>        
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <OpenStackServicesViewRegion
                    key={index}
                    {...item}
                    billingServices={billingServices}
                    showBillingFields={getRegionChecked(item)}
                  />
                </AccordionDetails>              
              </Accordion>            
            ))
          }

        </AccordionDetails>
      </Accordion>
    </>
  )
}

export default OpenStackServicesViewService